// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { AccountWidgetItemViewModel } from '../../ViewModels/AccountWidgetItemViewModel';
import React from 'react';
import AccWidgetDnDPlace from '@styles/webdesktop/Icons/accWidgetDnDPlace.svg';
export class AccountWidgetItem extends WMComponent {
    constructor(props) {
        super(props, AccountWidgetItemViewModel);
        this.DragNDropEnd = this.DragNDropEnd.bind(this);
        this.accWidgetTileOver = this.accWidgetTileOver.bind(this);
        this.accWidgetTileLeave = this.accWidgetTileLeave.bind(this);
    }
    DragNDropEnd() {
        this.viewModel.hovered = false;
        this.props.onItemDragNDropEnd(this.props.itemKey);
    }
    accWidgetTileOver() {
        this.viewModel.hovered = true;
    }
    accWidgetTileLeave() {
        this.viewModel.hovered = false;
    }
    render() {
        const { DragNDropInProcess } = this.props;
        if (DragNDropInProcess) {
            return this.renderDragNDropWidget();
        }
        else {
            return this.renderInfoWidget();
        }
    }
    renderDragNDropWidget() {
        const { hovered } = this.state;
        return (React.createElement("div", { className: `js-accWidget-AddWidget ${hovered ? 'hovered' : ''}`.trim(), onMouseUp: this.DragNDropEnd, onMouseEnter: this.accWidgetTileOver, onMouseLeave: this.accWidgetTileLeave },
            React.createElement(AccWidgetDnDPlace, null)));
    }
    renderInfoWidget() {
        const { tooltip, header, firstValue, firstValueColor, secondValue, secondValueColor } = this.state;
        return (React.createElement("div", { className: "js-accWidget-info", "data-tooltip": tooltip },
            React.createElement("div", { className: "js-top-infoDiv", style: { pointerEvents: 'none' } }, header),
            React.createElement("div", { className: "js-bottom-infoDiv", style: { pointerEvents: 'none' } },
                React.createElement("div", { className: firstValueColor }, firstValue),
                secondValue && (React.createElement(React.Fragment, null,
                    React.createElement("div", null, "/"),
                    React.createElement("div", { className: secondValueColor }, secondValue))))));
    }
}
